function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "google-play",
  transform: "translate(-29.101 0.528)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_276",
  "data-name": "Path 276",
  d: "M265.765,170.058l-4.71-2.72L254.6,172.16l6.453,4.822,4.726-2.73a2.448,2.448,0,0,0-.016-4.194Z",
  transform: "translate(-212.763 -158.237)",
  fill: "#fff",
  stroke: "#ac1ede",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_277",
  "data-name": "Path 277",
  d: "M43.469,25.987l-5.71,7.342-7.424,5.846a2.479,2.479,0,0,1-.734-1.762V14.52a2.479,2.479,0,0,1,.734-1.762l7.424,5.887Z",
  transform: "translate(0 -12.064)",
  fill: "#fff",
  stroke: "#ac1ede",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_278",
  "data-name": "Path 278",
  d: "M256.233,219.4l-1.632,2.1V217.3Z",
  transform: "translate(-212.763 -205.481)",
  fill: "#fff",
  stroke: "#ac1ede",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_279",
  "data-name": "Path 279",
  d: "M61.064,9.094l-4.829,4.829L43.1.694a3.679,3.679,0,0,1,.506-.375,2.416,2.416,0,0,1,2.48.049L54.6,5.374Z",
  transform: "translate(-12.766)",
  fill: "#fff",
  stroke: "#ac1ede",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_280",
  "data-name": "Path 280",
  d: "M261.062,102.52l-4.829,4.829-1.632-1.632V98.8Z",
  transform: "translate(-212.763 -93.426)",
  fill: "#fff",
  stroke: "#ac1ede",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_281",
  "data-name": "Path 281",
  d: "M61.064,260.829l-6.461,3.72-8.533,4.982a2.485,2.485,0,0,1-1.256.359,2.532,2.532,0,0,1-1.207-.326,3.681,3.681,0,0,1-.506-.375L56.235,256Z",
  transform: "translate(-12.766 -242.077)",
  fill: "#fff",
  stroke: "#ac1ede",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_282",
  "data-name": "Path 282",
  d: "M261.062,260.829l-6.461,3.72v-6.918L256.233,256Z",
  transform: "translate(-212.763 -242.077)",
  fill: "#fff",
  stroke: "#ac1ede",
  strokeWidth: 1
}));

var SvgGooglePlay = function SvgGooglePlay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.593,
    height: 28.841,
    viewBox: "0 0 25.593 28.841",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGooglePlay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-play.38d22297.svg";
export { ForwardRef as ReactComponent };